import { useEffect, useState } from 'react'

import { cn } from '@/utils/style'

interface RadioProps {
  checked?: boolean
  className?: string
  children?: React.ReactNode
  disabled?: boolean
  onChange?: (checked: boolean) => void
}

export function Radio({ checked, className, children, disabled = false, onChange }: RadioProps) {
  const [selected, setSelected] = useState(checked ?? false)

  useEffect(() => {
    if (disabled) return

    setSelected(checked ?? false)
  }, [checked, disabled])

  return (
    <label className={cn('flex items-center gap-1', className)}>
      <input
        type="radio"
        className={cn('w-[18px] h-[18px] text-btn-secondary', {
          'bg-panel-gray-200 cursor-not-allowed': disabled,
        })}
        disabled={disabled}
        checked={selected}
        onChange={(e) => {
          setSelected(e.target.checked)
          onChange && onChange(e.target.checked)
        }}
      />
      {children}
    </label>
  )
}
